var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7778 5.93037C14.0462 6.19885 14.0462 6.63416 13.7778 6.90264L9.68062 10.9998L13.7778 15.0971C14.0462 15.3656 14.0462 15.8008 13.7778 16.0693C13.5093 16.3378 13.074 16.3378 12.8055 16.0693L8.22218 11.4859C8.09325 11.3571 8.02081 11.1822 8.02081 10.9998C8.02081 10.8175 8.09325 10.6426 8.22218 10.5137L12.8055 5.93037C13.074 5.66188 13.5093 5.66188 13.7778 5.93037Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowLogin);
export default __webpack_public_path__ + "static/media/back_arrow_login.d22bad583bdd16460f8b3b639ef8a311.svg";
export { ForwardRef as ReactComponent };